import React from "react";
import PropTypes from "prop-types";
import ContactUsForm from "./ContactUsForm/ContactUsForm";
import OptionsToContact from "./OptionsToContact/OptionsToContact";
import ContactUsConfirmation from "./ContactUsConfirmation/ContactUsConfirmation";
import OrStrip from "./OrStrip/OrStrip";
import styles from "./styles.less";

// summery: contact us compund component,
// enter children as you like using one of the following: [ContactUsForm, OptionsToContact, ContactUsConfirmation]
// props: -all the required data for the contact us model (inc searchdata model)
//        -onSubmit function to start ajax action to api contact us method.
//
class ContactUs extends React.Component {
  onSubmit = data => {
    const {
      checkinDate,
      checkoutDate,
      selectedOption,
      onSubmit,
      pax,
      room,
      lang
    } = this.props;
    const { firstName, lastName, email, phone, message, requestType } = data;
    let paxModel = [];
    paxModel.push(pax);
    let roomTypes = [];
    roomTypes.push(room && room.name);

    const emailModel = {
      FirstName: firstName,
      LastName: lastName,
      Phone: phone,
      Email: email,
      MessageContent: message,
      RequestType: requestType,
      SearchDetails: {
        CheckIn: checkinDate,
        CheckOut: checkoutDate,
        SelectedOption: selectedOption,
        Pax: paxModel,
        RoomTypes: roomTypes
      }
    };
    const formData = {
      emailModel: emailModel,
      lang: lang
    };
    onSubmit(formData);
  };

  render() {
    const { children } = this.props;
    // const children = React.Children.toArray(this.props.children).map(child => {
    //   if (child.type.name === "ContactUsForm") {
    //     return React.cloneElement(child, {
    //       onSubmit: this.onSubmit
    //     });
    //   }
    //   return child;
    // });

    return (
      <div className={styles.contactUsWrapper}>
        {children({ onSubmit: this.onSubmit })}
      </div>
    );
  }
}

ContactUs.OptionsToContact = OptionsToContact;
ContactUs.ContactUsForm = ContactUsForm;
ContactUs.ContactUsConfirmation = ContactUsConfirmation;
ContactUs.OrStrip = OrStrip;

ContactUs.propTypes = {
  checkinDate: PropTypes.string.isRequired,
  checkoutDate: PropTypes.string.isRequired,
  selectedOption: PropTypes.object,
  pax: PropTypes.object,
  room: PropTypes.object,
  lang: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.func
};

export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/common/ContactUs/ContactUs.js